module.exports = __webpack_public_path__ + "assets/img/2021-10-active.1e97e3b6.png";